import { Routes, Route } from 'react-router-dom';
import { RequireRole } from '../guards/RequireRole';
import AppLayout from '../../components/AppLayout';
import AdminDashboard from '../../features/admin/pages/AdminDashboard';
import HostApprovals from '../../features/admin/pages/HostApprovals';
import TripApprovals from '../../features/admin/pages/TripApprovals';

export const AdminRoutes = () => {
  return (
    <RequireRole roles="admin">
      <AppLayout>
        <Routes>
          <Route index element={<AdminDashboard />} />
          <Route path="hosts" element={<HostApprovals />} />
          <Route path="trips" element={<TripApprovals />} />
        </Routes>
      </AppLayout>
    </RequireRole>
  );
};

